import { combineReducers } from "redux";
import { newsListReducer } from "redux/reducers/NewsReducers/newsListReducer";
import { singleNewsReducer } from "redux/reducers/NewsReducers/singleNewsReducer";
import { setQuickDonatePopStateReducer } from "redux/reducers/QuickDonatePop/setQuickDonatePopStateReducer";
import { getOrphanListReducer } from "redux/reducers/OrphansSponsorshipReducer/orphansListReducer";
import { getCountriesReducer } from "redux/reducers/RegiteringListsReducers/getCountriesReducer";
import { getCitiesReducer } from "redux/reducers/RegiteringListsReducers/getCitiesReducer";
import { getTitlesReducer } from "redux/reducers/RegiteringListsReducers/getTitlesReducer";
import { userRegisterReducer } from "redux/reducers/auth/registerReducer";
import { loginReducer } from "redux/reducers/auth/loginReducer";
import { campaignListReducer } from "redux/reducers/CampaignList/campaignListReducer";
import { seasonalProjectsReducer } from "redux/reducers/SeasonalprojectsReducer/seasonalProjectsReducer";
import { internalProjectsReducer } from "redux/reducers/internalProjectsReducer/internalProjectsReducer";
import { humanitarainCasesReducer } from "redux/reducers/HumanitarianCasesRudecer/humanitarianCasesReducer";
import { donationProjectDetailsByIdReducer } from "redux/reducers/ProjectDetailsByIdReducer/donationProjectDetailsByIdReducer";
import { humanProjectDetailsByIdReducer } from "redux/reducers/ProjectDetailsByIdReducer/humanProjectDetailsByIdReducer";
import { recentProjectDetailsReducer } from "redux/reducers/ProjectDetailsByIdReducer/recentProjectDetailsReducer";
import { newsLetterReducer } from "redux/reducers/NewsLetter/newsLetterReducer";
import { contactUsReducer } from "redux/reducers/ContactUs/contactUsReducer";
import { videosReducer } from "redux/reducers/VideosReducer/videosReducer";
import { smsDonationReducer } from "redux/reducers/SMS Donation/smsDonationReducer";
import { quickDonateReducer } from "redux/reducers/QuickDonate/quickDonateReducer";
import { requestSecureUrlReducer } from "redux/reducers/RequestSecureUrl/requestSecureUrlReducer";
import { donationHistoryReducer } from "redux/reducers/DonationHistory/donationHistoryReducer";
import { userAddCartItemsReducer } from "redux/reducers/Cart/userAddCartItems";
import { userGetCartItemsReducer } from "redux/reducers/Cart/userGetCartItemsReducer";
import { userDeleteCartItem } from "redux/reducers/Cart/userDeleteCartItem";
import { guestCartReducer } from "redux/reducers/Cart/guestCartReducer";
import { generateOtpResetPassword } from "redux/reducers/auth/ResetPassword/generateOtpResetPassword";
import { resetPasswordReducer } from "redux/reducers/auth/ResetPassword/resetPasswordReducer";
import { validateOtpResetPasswordReducer } from "redux/reducers/auth/ResetPassword/validateOtpResetPasswordReducer";
import { paymentStatusReducer } from "./reducers/paymentStatusReducer";
import { userAdjustCartItemReducer } from "./reducers/Cart/userAdjustCartItemReducer";
import { getExternalProjectsCategoriesReducer } from "./reducers/ExternalProjects/getExternalProjectsCategoriesReducer";
import { getExternalProjectsSubCategoriesReducer } from "./reducers/ExternalProjects/getExternalProjectsSubCategoriesReducer";
import { getExternalProjectsCountriesReducer } from "./reducers/ExternalProjects/getExternalProjectsCountriesReducer";
import { getExternalProjectsListReducer } from "./reducers/ExternalProjects/getExternalProjectsListReducer";
import { getExternalProjectsDetailsReducer } from "./reducers/ExternalProjects/getExternalProjectsDetailsReducer";
import { getUserProfileDetailsReducer } from "./reducers/UserProfile/getUserProfileDetailsReducer";

export const appReducer = combineReducers({
  newsListReducer,
  singleNewsReducer,
  setQuickDonatePopStateReducer,
  getOrphanListReducer,
  getCountriesReducer,
  getCitiesReducer,
  getTitlesReducer,
  userRegisterReducer,
  loginReducer,
  campaignListReducer,
  seasonalProjectsReducer,
  internalProjectsReducer,
  humanitarainCasesReducer,
  donationProjectDetailsByIdReducer,
  humanProjectDetailsByIdReducer,
  recentProjectDetailsReducer,
  newsLetterReducer,
  contactUsReducer,
  videosReducer,
  smsDonationReducer,
  quickDonateReducer,
  requestSecureUrlReducer,
  donationHistoryReducer,
  userAddCartItemsReducer,
  userGetCartItemsReducer,
  userDeleteCartItem,
  guestCartReducer,
  generateOtpResetPassword,
  resetPasswordReducer,
  validateOtpResetPasswordReducer,
  paymentStatusReducer,
  userAdjustCartItemReducer,
  getExternalProjectsCategoriesReducer,
  getExternalProjectsSubCategoriesReducer,
  getExternalProjectsCountriesReducer,
  getExternalProjectsListReducer,
  getExternalProjectsDetailsReducer,
  getUserProfileDetailsReducer,
});

export const rootReducers = (state: any, action: any) => {
  if (action.type === "LOG_OUT") {
    return appReducer(
      {
        ...state,
        userRegisterReducer: undefined,
        loginReducer: undefined,
        cartReducer: undefined,
      },
      action
    );
  }
  if (action.type === "SET_SecureUrlData") {
    return appReducer(
      {
        ...state,
        requestSecureUrlReducer: undefined,
      },
      action
    );
  }

  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducers>;
